const mutations = {
    SET_ERROR_CUSTOM_LINKS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
